import { Box, Masonry, useRouter, useTheme } from '@forgeglobal/design-framework'
import { ClientContext } from 'components/opportunities/ClientContext'
import { HoldingCard } from 'components/holdings/HoldingCard'
import { LastRoundDetails } from 'components/issuers/LastRoundDetails'
import { OpportunityAccountPanel } from 'components/opportunities/OpportunityAccountPanel'
import { OpportunityDetailsPanel } from 'components/opportunities/OpportunityDetailsPanel'
import { OpportunityHeader } from 'components/opportunities/OpportunityHeader'
import { useOpportunityQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment } from 'react'

export const Opportunity: React.FC = () => {
  const theme = useTheme()
  const { match } = useRouter<{ id: string }>()
  const { data } = useOpportunityQuery({ variables: { id: match.params.id } })
  const holdingId = data?.opportunity?.trade_intent.holding?.id

  const sections = [
    <OpportunityAccountPanel key="account" />,
    holdingId && <HoldingCard key="holding" holdingId={holdingId} />,
    <ClientContext key="account_context" />,
    <OpportunityDetailsPanel key="details" opportunityId={match.params.id} />,
    <LastRoundDetails key="last_round_detail" />,
  ].filter(e => !!e)

  return (
    <Fragment>
      <OpportunityHeader />
      <Box style={{ padding: theme.content.padding, paddingTop: 0, overflowAnchor: 'none', minHeight: '90vh' }}>
        <Masonry items={sections} />
      </Box>
    </Fragment>
  )
}
